export default function createAboPaths(source)
{
    const original = source.replace(/(\/product-images\/.*?\/product-.*?)\//, '$1-abo/');
    const jpgImage = source.replace(/(\/product-images\/.*?\/product-.*?)\/(.*?)(\.jpg)$/, '$1-abo/$2.jpg');
    const jpgRetinaImage = source.replace(/(\/product-images\/.*?\/product-.*?)\/(.*?)(\.jpg)$/, '$1-abo/$2-2x.jpg');
    const webPImage = source.replace(/(\/product-images\/.*?\/product-.*?)\/(.*?)(\.jpg)$/, '$1-abo/$2.webp');
    const webPRetinaImage = source.replace(/(\/product-images\/.*?\/product-.*?)\/(.*?)(\.jpg)$/, '$1-abo/$2-2x.webp');
    const avifImage = source.replace(/(\/product-images\/.*?\/product-.*?)\/(.*?)(\.jpg)$/, '$1-abo/$2.avif');
    const avifRetinaImage = source.replace(/(\/product-images\/.*?\/product-.*?)\/(.*?)(\.jpg)$/, '$1-abo/$2-2x.avif');

    return {
        original: original,
        jpgImage: jpgImage,
        jpgRetinaImage: jpgRetinaImage,
        webPImage: webPImage,
        webPRetinaImage: webPRetinaImage,
        avifImage: avifImage,
        avifRetinaImage: avifRetinaImage
    };
}
